<template>
  <div class="js" >
    <div class="container">
      <!-- 右侧 -->
      <div class="js-r">
        <h2>欢游互动（北京）科技有限公司</h2>
        <p> 欢游互动(北京)科技有限公司成立于2018年05月21日，注册地位于北京市石景山区实兴东街11号1层1324室,经营范围包括技术开发、技术咨询、技术服务、技术推广、技术转让；软件开发；产品设计；技术进出口、货物进出口；企业营销策划；市场调查；会议服务；计算机系统服务；文化咨询；体育咨询；公共关系服务；数据处理（数据处理中的银行卡中心、PUE值在1.5以上的云计算数据中心除外）；组织文化艺术交流活动（不含演出）；承办展览展示活动；设计、制作、代理、发布广告；经济贸易咨询；房地产信息咨询；企业管理咨询；体育运动项目经营（高危险性体育项目除外）等。。。</p>
        
     
      </div>
      <!-- 左侧 -->
      <div class="js-l">
        <img src="/imgs/js1.jpg" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";
.js {
  width: 100%;
  height: 360px;
  margin: 50px auto;

  // background: pink;
  .container {
    @include flex();

    height: 100%;
    .js-l {
      width: 50%;
      height: 100%;
      background: #c59012;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .js-r {
      width: 50%;
      height: 100%;
      background-color: #fff;
      margin-left: 30px;
      padding: 20px;
      box-sizing: border-box;
      h2 {
        font-size: 21px;
        font-weight: 400;
        color: #333;
      }
      p {
        font-size: 14px;
        color: #888;
        line-height: 30px;
        margin: 35px 0;
        text-indent: 20px;
      }
    }
  }
}
</style>